// @flow

import { closeFileViewerModal } from '../State/fileViewerModal';

export default () => (dispatch: Function) => {
  dispatch(closeFileViewerModal());
};
